{
  "sidebar": {
    "description": "Här kan du reservera åtkomst för dig själv. Åtkomsten täcker en person.",
    "ownAccessNone": "Dina gym-åtkomsträttigheter: Du har för närvarande inga giltiga gym-åtkomsträttigheter.",
    "ownAccessWithCount_one": "Dina gym-åtkomsträttigheter: Du har en giltig gym-åtkomsträttighet.",
    "ownAccessWithCount_other": "Dina gym-åtkomsträttigheter: Du har {{count}} giltiga gym-åtkomsträttigheter.",
    "ownAccessLoading": "Dina gym-åtkomsträttigheter: laddar..."
  },
  "modal": {
    "title": "Reservera",
    "releaseTitle": "Släpp",
    "headerReserve": "Gym-åtkomst",
    "headerRelease": "Gym-åtkomst",
    "gymRulesLink": "Regler",
    "gymAccessTermsLink": "Reservationsvillkor",
    "acceptRules": "Jag accepterar reglerna och åtkomstreservationsvillkoren",
    "cancel": "Avbryt",
    "confirm": "Bekräfta",
    "priceLabel": "Pris",
    "perMonth": "€ / månad"
  },
  "reservation": {
    "title": "Gym",
    "availabilitySentence": "Det finns för närvarande",
    "availabilitySentenceBold": "{{count}} tillgängliga pass på gymmet.",
    "today": "Idag",
    "priceLabel": "Pris",
    "priceAtStart": "Pris vid avtalets början {{price}} € / månad.",
    "buttonReserve": "Reservera",
    "buttonRelease": "Frisläpp åtkomst",
    "releaseAccessEnding": "Den här åtkomsten är redan avslutad och kan inte ändras.",
    "releaseAccessFuture": "Framtida bokningar kan avbokas via kundtjänst.",
    "releaseAccessUnavailable": "Endast avtalsparten eller betalaren kan släppa åtkomsten.",
    "currentAccessTitle": "Nuvarande reservationer",
    "validUntil": "Giltig {{startDate}} - {{endDate}}.",
    "validFrom": "Giltig från och med {{startDate}}, tills vidare.",
    "endsOnLabel": "Upphör {{endDate}}",
    "activeLabel": "Giltig",
    "reachedLimitInfo": "Du har nått det maximala antalet aktiva bokningar ({{max}}) och kan inte göra fler bokningar.",
    "accessSummary": {
      "none": "Du har för närvarande ingen giltig gymåtkomst.",
      "active_one": "Du har en giltig gymåtkomst.",
      "active_other": "Du har {{count}} giltiga gymåtkomster.",
      "terminating": "Du har sagt upp din gymåtkomst. Din åtkomst är giltig till {{endDate}}."
    }
  },
  "reservationModal": {
    "reservationStartsLabel": "Reservation träder i kraft",
    "successTitle": "Åtkomst reserverad!",
    "successMessage": "Gym-åtkomst har nu reserverats!",
    "accessStartsLabel": "Åtkomst startar:",
    "priceLabel": "Pris:",
    "perMonth": "€ / månad",
    "acceptRules": "Jag accepterar {{address}} regler och gym-åtkomstreservationsvillkor",
    "contractNotStartedError": "Reservationen kan inte börja före avtalets startdatum."
  },
  "releaseModal": {
    "successTitle": "Åtkomst borttagen!",
    "successMessage": "Gym-åtkomst har nu tagits bort!",
    "confirmQuestion": "Är du säker på att du vill släppa åtkomsten?",
    "accessDetails": "Åtkomst: {{address}}, giltig från {{startDate}}.",
    "validUntilImmediate": "Om du avslutar din åtkomst nu upphör den omedelbart.",
    "validUntilPrefix": "Om du avslutar din åtkomst nu kommer den att vara giltig till",
    "validUntilSuffix": "."
  },
  "noCalendarsAvailable": "Inga reservationskalendrar tillgängliga",
  "timeFormatting": {
    "startingFrom": "från och med",
    "priceAddedToContract": "läggs till ditt kontrakt"
  }
}
